import Table from "components/Table/Table";
import { useGetClaimCMPAlertsQuery } from "services/claims-api";
import type { ClaimsDataType, CMPAlert } from "types/DataTypes";
import { formatCurrency } from "utils/format-utils";

type ClaimCMPItemListProps = {
  claim: ClaimsDataType;
};

const ClaimCMPItemList = ({ claim }: ClaimCMPItemListProps) => {
  const { data: cmpAlerts, error: errorInfo } = useGetClaimCMPAlertsQuery(
    { claimId: claim?.id },
    {
      skip: !claim?.id,
      refetchOnMountOrArgChange: true,
    },
  );

  if (!claim?.id) {
    return null;
  }

  const columns = [
    {
      key: "item_type",
      name: "Type",
      width: "10%",
      renderCell: (_props: { row: CMPAlert }) => {
        if (_props.row.item_type === "TOTAL") {
          return <div style={{ fontWeight: "bold" }}>TOTAL</div>;
        }
        return <div>{_props.row.item_type.toUpperCase()}</div>;
      },
    },
    {
      key: "penalty_amount",
      name: "Penalty",
      width: "10%",
      cellClass: "currency-cell",
      renderCell: (_props: { row: CMPAlert }) => {
        if (_props.row.item_type === "TOTAL") {
          return (
            <div style={{ fontWeight: "bold" }}>
              {formatCurrency(_props.row.penalty_amount) || "-"}
            </div>
          );
        }
        return <div>{formatCurrency(_props.row.penalty_amount) || "-"}</div>;
      },
    },
    {
      key: "penalty_amount_with_inflation",
      name: "Penalty + Inflation",
      width: "10%",
      cellClass: "currency-cell",
      renderCell: (_props: { row: CMPAlert }) => {
        if (_props.row.item_type === "TOTAL") {
          return (
            <div style={{ fontWeight: "bold" }}>
              {formatCurrency(_props.row.penalty_amount_with_inflation) || "-"}
            </div>
          );
        }
        return (
          <div>
            {formatCurrency(_props.row.penalty_amount_with_inflation) || "-"}
          </div>
        );
      },
    },
    {
      key: "days_active",
      name: "Days Late",
      width: "15%",
      // ...commonColumnProps,
    },
    {
      key: "description",
      name: "Description",
      width: "65%",
    },
  ];

  const alerts =
    cmpAlerts?.length === 0
      ? []
      : (cmpAlerts || []).concat([
          {
            item_key: "total",
            item_type: "TOTAL",
            days_active: "-",
            description: "-",
            penalty_amount_with_inflation: (cmpAlerts || []).reduce(
              (acc, alert) => acc + alert.penalty_amount_with_inflation,
              0,
            ),
            penalty_amount: (cmpAlerts || []).reduce(
              (acc, alert) => acc + alert.penalty_amount,
              0,
            ),
          },
        ]);

  const errorOccurred =
    errorInfo &&
    typeof errorInfo === "object" &&
    "status" in errorInfo &&
    errorInfo.status === 500;

  return (
    <div className="special-client-instructions card form">
      <div className="card__header">CMP Alerts</div>

      <Table
        className="table client-instructions-table"
        columns={columns}
        rows={errorOccurred ? [] : alerts}
        rowKeyGetter={(row: CMPAlert) => row.item_key}
        emptyTableMessage={
          errorOccurred ? "Error calculating CMP alerts" : "No Alerts"
        }
      />
    </div>
  );
};

export default ClaimCMPItemList;
